"use client";

import React from "react";

//Types
import { SmallTitleProps } from "@/types";

//Styles
import * as S from "./styles";

const SmallTitleModal: React.FC<SmallTitleProps> = ({
  Title,
  alignText = "left",
  mb,
}) => {
  return (
    <S.SmallTitle $alignText={alignText} $mb={mb}>
      {Title}
    </S.SmallTitle>
  );
};

export default SmallTitleModal;
